






































































































































//@ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";

import CompliantsCombobox from "@/components/Controls/CompliantsCombobox.vue";
import Attachments from "@/components/Controls/Attachments.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",
      "items",
      "months"
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, ["setReportOptions", "exportDataAsXLSX"])
  },
  components: {
    TitleBar,
    CompliantsCombobox,
    Attachments
  }
})
export default class PrimeCostsReport extends Vue {
  get titleStack() {
    return ["Отчеты", "Изменению себестоимости"];
  }

  localFilter = {
    date_from: moment()
      .startOf("month")
      .toDate(),
    date_to: moment()
      .startOf("month")
      .toDate(),
    products: []
  };

  get defaultSort() {
    return [
      this.$route.query.sortField || "client_name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.localFilter.date_from =
      this.$route.query && this.$route.query.date_from
        ? moment(this.$route.query.date_from).toDate()
        : moment()
            .startOf("month")
            .toDate();
    this.localFilter.date_to =
      this.$route.query && this.$route.query.date_to
        ? moment(this.$route.query.date_to).toDate()
        : moment()
            .startOf("month")
            .toDate();
    this.localFilter.products =
      this.$route.query && this.$route.query.products
        ? this.$route.query.products
        : [];
    this.localFilter.products = Array.isArray(this.localFilter.products)
      ? this.localFilter.products
      : [this.localFilter.products];

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      switch (key) {
        case "date_from":
        case "date_to":
          ac[key] = moment(this.localFilter[key]).format("YYYY-MM-DD");
          break;
        default:
          ac[key] = this.localFilter[key];
      }
      return ac;
    }, {});

    this.$router.replace({
      query
    });
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
